<template>
    <div class="components-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-select v-model="queryForm.majorPropCode" placeholder="专业性质" style="width:170px;" clearable>
                <el-option v-for="(item, index) in comboOption.majorProp" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.deptCode" placeholder="系部名称" style="width:170;" clearable>
                <el-option v-for="(item, index) in comboOption.dept" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.majorName" placeholder="专业名称" style="width:170px;"></el-input>
            <el-select v-model="queryForm.isUsed" placeholder="是否使用" style="width:120px;" clearable>
                <el-option v-for="(item, index) in comboOption.isUsed" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addMajor" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</el-button>
            <el-button @click="delMajor" type="danger"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="专业性质" prop="majorPropName" width="80px" align="center"></el-table-column>
            <el-table-column label="系部名称" prop="deptName" align="center"></el-table-column>
            <el-table-column label="专业代码" prop="majorCode" width="80px" align="center"></el-table-column>
            <el-table-column label="专业名称" prop="majorName" align="center"></el-table-column>
            <el-table-column label="国标专业代码" prop="standardMajorCode" width="110px" align="center"></el-table-column>
            <el-table-column label="国标专业名称" prop="standardMajorName" align="center"></el-table-column>
            <el-table-column label="是否使用" prop="isUsed" :formatter="isUsedFormatter" width="80px" align="center"></el-table-column>
        </el-table>

        <el-dialog title="添加" :visible.sync="dialogVisible" width="600px" top="100px" append-to-body>
            <el-input style="width:300px; margin-bottom:10px;" placeholder="查询" clearable v-model="treeFilterText"></el-input>
            <div style="height:500px; overflow:auto;">
                <el-tree ref="majorTree" :data="treeData" node-key="id" :props="defaultProps" :default-expanded-keys="['0']"T
                    :filter-node-method="filterNode" show-checkbox>
                </el-tree>
            </div>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" @click="saveMajor">确定</el-button>
                <el-button @click="dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        props: ['curPreCourseCode', 'listHeight'],
        data() {
            return {
                userRole: [],
                //查询列表数据
                queryForm: {
                    majorPropCode: null,
                    deptCode: null,
                    majorName: null,
                    preCourseCode: null,
                },
                //下拉框选项数据
                comboOption: {
                   dept: null,
                   majorProp: null,
                   isUsed: null,
                },
                //表数据
                tableData: [],
                tableLoading: true,
                mainTableHeight: 500,
                selectRowData: null,
                loadingMask: null,
                dialogVisible: null,
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                treeFilterText: null,
            }
        },
        mounted() {
            this.queMajorList();

            this.$nextTick().then(() => {
                if(this.listHeight){
                    this.mainTableHeight = this.listHeight;
                }else{
                    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                    //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                    this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                    // 监听窗口大小变化
                    let self = this;
                    window.onresize = function() {
                        self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                    };
                }
            });
        },
        watch: {
            treeFilterText(val) {
                this.$refs.majorTree.filter(val);
            }
        },
        methods: {
            queMajorList() {
                this.tableLoading = true;

                this.$api.teachingManage.coursePreConfig.queMajorList({
                    data: this.queryForm,
                }).then((res) => {
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            isUsedFormatter(row) {
                return row.isUsed === '1' ? '是' : '否';
            },
            //页码区域方法
            handleCurrentChange(val, old) {
                this.selectRowData = val;
            },
            handleFilter() {
                this.queMajorList();
            },
            handleReset() {
                this.queryForm.majorPropCode = null;
                this.queryForm.deptCode = null;
                this.queryForm.majorName = null;
                this.queryForm.isUsed = null;
                this.queMajorList();
            },
            addMajor(){
                this.dialogVisible = true;
                this.treeFilterText = null;
                this.queMajorTree();
            },
            queMajorTree(){
                this.$api.teachingManage.coursePreConfig.queMajorTree({
                    data: this.queryForm,
                }).then((response) => {
                    this.treeVisible = true;
                    this.treeData = response.data.data;
                }).catch(error => {
                    console.log(error);
                });
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            saveMajor(){
                //获取选中的专业信息
                let selNodes = this.$refs.majorTree.getCheckedNodes();

                if(selNodes.length === 0){
                    this.$alert('请至少选择一个专业', '提示', {
                        confirmButtonText: '确定',
                    });
                    return;
                }

                let majorCodeArray = new Array();
                for(let i=0; i<selNodes.length; i++){
                    if(selNodes[i].nodeType === 'major'){
                        majorCodeArray.push(selNodes[i].id);
                    }
                }

                const params = {
                    preCourseCode: this.queryForm.preCourseCode,
                    majorCodes: majorCodeArray.toString(),
                };
                this.$api.teachingManage.coursePreConfig.saveMajorRec({
                    data: params
                }).then((res) => {
                    let state = res.data.data.state;
                    switch (state) {
                        case 'success':
                            showNotify('成功', '保存成功', 'success', 1500);
                            this.queMajorList();
                            this.dialogVisible = false;
                            break;
                        default:
                            showNotify('错误', '保存失败', 'error', 3000);
                            break;
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            delMajor(rowData){
                //获取选择的专业信息
                let selMajors = this.$refs.mainTable.selection;
                if(selMajors.length === 0){
                    this.$alert('请至少选择一个专业', '提示', {
                        confirmButtonText: '确定',
                    });
                    return;
                }

                let idArray = new Array();
                for(let i=0; i<selMajors.length; i++){
                    idArray.push(selMajors[i].id);
                }

                confirmMsg('是否确定要删除当前选择的专业信息').then(() => {
                    this.$api.teachingManage.coursePreConfig.delMajorRec({
                        data: {
                            ids: idArray.toString(),
                        }
                    }).then((res) => {
                        let state = res.data.data.state;
                        switch (state) {
                            case 'success':
                                showNotify('成功', '删除成功', 'success', 1500);
                                this.queMajorList();
                                break;
                            default:
                                showNotify('错误', '删除失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
        }
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// majorConfig.vue?02278fb4